import { Project } from "domain-entities";
import { ProjectTree } from "./ProjectHelper";

export function getCleanSearch(search: string) {
	return search.toLowerCase().replace(/[,.-]/g, " ").trim();
}

export function getSearchValues(searchTerm: string) {
	return getCleanSearch(searchTerm)
		.split(" ")
		.filter((searchValue) => searchValue);
}

export function getMatchingProjectTrees(
	projectTrees: ProjectTree[],
	searchValues: string[]
) {
	return getProjectTreesClone(projectTrees).filter((projectTree) => {
		projectTree.children = projectTree.children.filter((child) => {
			return isProjectMatching(child, searchValues, projectTree.project);
		});

		return projectTree.children.length;
	});
}

function getProjectTreesClone(projectTrees: ProjectTree[]): ProjectTree[] {
	return projectTrees.map((projectTree) => {
		if (projectTree.project) {
			return {
				project: projectTree.project,
				children: [...projectTree.children],
			};
		} else {
			return {
				children: [...projectTree.children],
			};
		}
	});
}

function isProjectMatching(
	project: Project,
	searchValues: string[],
	parentProject?: Project
) {
	const value = getCleanSearch(
		[
			project.name,
			project.street,
			project.zipcode,
			project.city,
			parentProject?.name,
			...(project.contacts?.map((contact) => contact.name) || []),
		].join(" ")
	);

	return (
		searchValues.length === 0 ||
		searchValues.length ===
			searchValues.filter((searchValue) => value.includes(searchValue)).length
	);
}
